import AdminViewQuilty from "../views/admin/AdminViewQuilty.vue";
import { UserRole } from "@gsx/common";
import { Container } from "inversify";

import RequestListView from "../views/admin/request/RequestListView.vue";
import ReportsListView from "../views/admin/reports/ReportsListView.vue";
import ReportsCreateView from "../views/admin/reports/ReportsCreateView.vue";
import ReportsEditView from "../views/admin/reports/ReportsEditView.vue";
import ReportGeneralView from "../views/admin/reports/ReportGeneralView.vue";

import FlashNewsCreateView from "../views/admin/flashNews/FlashNewsCreateView.vue";
import FlashNewsEditView from "../views/admin/flashNews/FlashNewsEditView.vue";
import FlashNewsGeneralView from "../views/admin/flashNews/FlashNewsGeneralView.vue";
import FlashNewsListView from "../views/admin/flashNews/FlashNewsListView.vue";

import OrganizationListView from "../views/admin/organization/OrganizationListView.vue";
import OrganizationEditView from "../views/admin/organization/OrganizationEditView.vue";
import OrganizationEditProfileView from "../views/admin/organization/profile/OrganizationEditProfileView.vue";

import QuiltyInsightsCreateView from "../views/admin/quiltyInsights/QuiltyInsightsCreateView.vue";
import QuiltyInsightsEditView from "../views/admin/quiltyInsights/QuiltyInsightsEditView.vue";
import QuiltyInsightsGeneralView from "../views/admin/quiltyInsights/QuiltyInsightsGeneralView.vue";
import QuiltyInsightsListView from "../views/admin/quiltyInsights/QuiltyInsightsListView.vue";

import MergerAcquisitionsListview from "../views/admin/mergerAcquisitions/MergerAcquisitionsListView.vue";
import MergerAcquisitionsCreateView from "../views/admin/mergerAcquisitions/MergerAcquisitionsCreateView.vue";
import MergerAcquisitionsEditView from "../views/admin/mergerAcquisitions/MergerAcquisitionsEditView.vue";

import QuiltyResourceListView from "../views/admin/quiltyResources/QuiltyResourceListView.vue";
import QuiltyResourceCreateView from "../views/admin/quiltyResources/QuiltyResourceCreateView.vue";
import QuiltyResourceGeneralView from "../views/admin/quiltyResources/QuiltyResourceGeneralView.vue";
import QuiltyResourceEditView from "../views/admin/quiltyResources/QuiltyResourceEditView.vue";

import { AuthGate } from "../../../common/src/AuthGate";

import UserAccountsView from "../views/admin/accounts/UserAccountsView.vue";
import UserActivityLogsView from "../views/admin/activityLogs/UserActivityLogsView.vue";
import { RouteConfig } from "vue-router";
import AccountCreationView from "../views/admin/accounts/AccountCreationView.vue";

export const createThirdPartyAdminRoutes = (container: Container): RouteConfig[] => {
    const authGate: AuthGate = container.get(AuthGate);

    return [
        {
            path: "/quiltyAdmin",
            redirect: "/quiltyAdmin/accounts",
            component: AdminViewQuilty,
            beforeEnter: authGate.requireAuthorizedGuard([UserRole.ThirdpartyAdmin]),
            meta: {
                breadcrumbs: [
                    {
                        name: "Home",
                        to: "/",
                    },
                    {
                        name: "Admin",
                        to: "/quiltyAdmin",
                    },
                ],
            },
            children: [
                {
                    path: "organizations",
                    component: OrganizationListView,
                    meta: {
                        title: "Organizations",
                    },
                },
                {
                    path: "organizations/:organization",
                    component: OrganizationEditView,
                    redirect: "organizations/:organization/profile",
                    meta: {
                        breadcrumbs: [
                            {
                                name: "Organizations",
                                to: "/quiltyAdmin/organizations",
                            },
                        ],
                        title: "Edit",
                    },
                    children: [
                        {
                            path: "profile",
                            component: OrganizationEditProfileView,
                            meta: {
                                breadcrumbs: [
                                    {
                                        name: "Organization",
                                        to: "/quiltyAdmin/organizations/:organization",
                                    },
                                ],
                                title: "Profile",
                            },
                        },
                        {
                            path: "quilty-resources",
                            component: QuiltyResourceListView,
                            meta: {
                                breadcrumbs: [
                                    {
                                        name: "Organization",
                                        to: "/admin/organizations/:organization",
                                    },
                                ],
                                title: "Quilty Resources",
                            },
                        },
                        {
                            path: "quilty-resources/create",
                            component: QuiltyResourceCreateView,
                            meta: {
                                breadcrumbs: [
                                    {
                                        name: "Organization",
                                        to: "/admin/organizations/:organization",
                                    },
                                    {
                                        name: "Quilty Resources",
                                        to: "/admin/organizations/:organization/quilty-resources/create",
                                    },
                                ],
                                title: "Create",
                            },
                        },
                        {
                            path: "quilty-resources/:quiltyResource",
                            component: QuiltyResourceEditView,
                            redirect: "quilty-resources/:quiltyResource/general",
                            meta: {
                                breadcrumbs: [
                                    {
                                        name: "Organization",
                                        to: "/admin/organizations/:organization",
                                    },
                                    {
                                        name: "Quilty Resources",
                                        to: "/admin/organizations/:organization/quilty-resources/edit",
                                    },
                                ],
                                title: "Edit",
                            },
                            children: [
                                {
                                    path: "general",
                                    component: QuiltyResourceGeneralView,
                                    meta: {
                                        breadcrumbs: [
                                            {
                                                name: "Quilty Resource",
                                                to: "/admin/general/:quiltyResourceId",
                                            },
                                        ],
                                        title: "General",
                                    },
                                },
                            ],
                        },
                    ],
                },
                {
                    path: "accounts",
                    component: UserAccountsView,
                    meta: {
                        title: "User Accounts",
                    },
                },
                {
                    path: "activity",
                    component: UserActivityLogsView,
                    meta: {
                        title: "User Activity",
                    },
                },
                {
                    path: "accountCreation",
                    component: AccountCreationView,
                    meta: {
                        title: "Account Creation",
                    },
                },
                {
                    path: "requests",
                    component: RequestListView,
                    meta: {
                        title: "Requests",
                    },
                },
                {
                    path: "reports",
                    component: ReportsListView,
                    meta: {
                        title: "Reports",
                    },
                },
                {
                    path: "reports/create",
                    component: ReportsCreateView,
                    meta: {
                        breadcrumbs: [
                            {
                                name: "Reports",
                                to: "/quiltyAdmin/reports",
                            },
                        ],
                        title: "Create",
                    },
                },
                {
                    path: "reports/:reportId",
                    component: ReportsEditView,
                    redirect: "reports/:reportId/general",
                    meta: {
                        breadcrumbs: [
                            {
                                name: "Reports",
                                to: "/quiltyAdmin/reports",
                            },
                        ],
                        title: "Edit",
                    },
                    children: [
                        {
                            path: "general",
                            component: ReportGeneralView,
                            meta: {
                                breadcrumbs: [
                                    {
                                        name: "Report",
                                        to: "/quiltyAdmin/general/:reportId",
                                    },
                                ],
                                title: "General",
                            },
                        },
                    ],
                },
                {
                    path: "flashNews",
                    component: FlashNewsListView,
                    meta: {
                        title: "FlashNews",
                    },
                },
                {
                    path: "flashNews/create",
                    component: FlashNewsCreateView,
                    meta: {
                        breadcrumbs: [
                            {
                                name: "Flash News",
                                to: "/quiltyAdmin/flashNews",
                            },
                        ],
                        title: "Create",
                    },
                },
                {
                    path: "flashNews/:flashNewsId",
                    component: FlashNewsEditView,
                    redirect: "flashNews/:flashNewsId/general",
                    meta: {
                        breadcrumbs: [
                            {
                                name: "FlashNews",
                                to: "/quiltyAdmin/flashNews",
                            },
                        ],
                        title: "Edit",
                    },
                    children: [
                        {
                            path: "general",
                            component: FlashNewsGeneralView,
                            meta: {
                                breadcrumbs: [
                                    {
                                        name: "Flash News",
                                        to: "/quiltyAdmin/general/:flashNewsId",
                                    },
                                ],
                                title: "General",
                            },
                        },
                    ],
                },
                {
                    path: "quiltyInsights",
                    component: QuiltyInsightsListView,
                    meta: {
                        title: "QuiltyInsights",
                    },
                },
                {
                    path: "quiltyInsights/create",
                    component: QuiltyInsightsCreateView,
                    meta: {
                        breadcrumbs: [
                            {
                                name: "Quilty Insights",
                                to: "/quiltyAdmin/quiltyInsights",
                            },
                        ],
                        title: "Create",
                    },
                },
                {
                    path: "quiltyInsights/:quiltyInsightsId",
                    component: QuiltyInsightsEditView,
                    redirect: "quiltyInsights/:quiltyInsightsId/general",
                    meta: {
                        breadcrumbs: [
                            {
                                name: "QuiltyInsights",
                                to: "/quiltyAdmin/quiltyInsights",
                            },
                        ],
                        title: "Edit",
                    },
                    children: [
                        {
                            path: "general",
                            component: QuiltyInsightsGeneralView,
                            meta: {
                                breadcrumbs: [
                                    {
                                        name: "Quilty Insights",
                                        to: "/quiltyAdmin/general/:quiltyInsightsId",
                                    },
                                ],
                                title: "General",
                            },
                        },
                    ],
                },
                {
                    path: "mergerAcquisitions",
                    component: MergerAcquisitionsListview,
                    meta: {
                        title: "Merger Acquisitions",
                    },
                },
                {
                    path: "mergerAcquisitions/create",
                    component: MergerAcquisitionsCreateView,
                    meta: {
                        breadcrumbs: [
                            {
                                name: "Merger Acquisitions",
                                to: "/admin/mergerAcquisitions",
                            },
                        ],
                        title: "Create",
                    },
                },
                {
                    path: "mergerAcquisitions/:mergerAcquisitionId",
                    component: MergerAcquisitionsEditView,
                    meta: {
                        breadcrumbs: [
                            {
                                name: "Merger Acquisitions",
                                to: "/admin/mergerAcquisitions",
                            },
                        ],
                        title: "Edit",
                    },
                },
            ],
        },
    ];
};
